import styled from 'styled-components';
import {tokensForThemeProvider} from '@forecast-it/design-system';

const tokens = tokensForThemeProvider.sky.sys;

/** The builder's quiet annotation text: 12px, auxiliary grey — `sky/sys/font/detail/1` at
 * `sky/sys/color/text/content/auxiliary`, the pair the design uses wherever a line comments on
 * something else on the page rather than being content itself. Used by the page header's
 * last-published caption and the row-count line above the table.
 *
 * A styled span reading those two tokens rather than the DS `Detail` component, whose own colour
 * map has no `auxiliary` — its options are `default` (#393946) and `medium` (#727483), and the
 * design names #6b6d7b. Overriding a wrapped `Detail`'s colour means fighting its generated class
 * in the cascade; naming the token the design names does not. The font is the same token `Detail`
 * itself applies at size 1.
 *
 * Extend with `styled(AuxiliaryDetail)` for a variant (see `PublishedCaption`, which adds
 * `white-space: nowrap`) — styled-components emits the extension's rules after these, so the
 * variant wins without any specificity trickery.
 */
export const AuxiliaryDetail = styled.span`
	${tokens.font.detail['1']};
	color: ${tokens.color.text.content.auxiliary};
`;
